import http from './http';

//新闻列表
/*
category_id	string			
分类ID  
keyword	string			
标题｜标签  
page_size	int		15	
当前条数  
page	int		1	
当前页  
*/
export function getNewsList(data: { category_id: string; keyword: string; page_size?: number; page?: number }) {
  const params = new URLSearchParams();
  if (data.category_id) params.append('category_id', data.category_id);
  if (data.keyword) params.append('keyword', data.keyword);
  if (data.page_size) params.append('page_size', String(data.page_size));
  if (data.page) params.append('page', String(data.page));
  return http.get(`/news/index?${params.toString()}`);
}
//新闻详情
export function getNewsDetails(data: { id: string;}) {
  const params = new URLSearchParams();
  if (data.id) params.append('id', data.id);
  return http.get(`/news/details?${params.toString()}`);
}
//新闻分类
export function getNewsCategorys() {
  return http.get('/news/categorys');
}
//新闻标签
export function getNewsTags() {
  return http.get('/news/tags');
}

//新闻点赞添加
export function getNewsLikeAdd(data: { id: string;}) {
  return http.post(`/newsLike/add`,data);
}
//新闻点赞取消
export function getNewsLikeOut(data: { id: string;}) {
  return http.post(`/newsLike/out`,data);
}

//新闻添加评论
/*
id	string			
新闻ID  
pid	string			
上级ID，多级回复，没有则为0  
content	string			
评论内容  
*/
export function getNewsCommentAdd(data: { id: string;pid?: string;content: string}) {
  return http.post(`/newsComment/add`,data);
}

//新闻评论列表
/*
id	string
新闻ID*/
export function getNewsCommentList(data: { id: string; }) {
  return http.post(`/newsComment/index`,data);
}




